// extracted by mini-css-extract-plugin
export default {"banner":"DemoToast_banner__BWhUO","icon":"DemoToast_icon__d8PBV","title":"DemoToast_title__oypKE","message":"DemoToast_message__9vHPZ","dismissBtn":"DemoToast_dismissBtn__qzVst"};